import * as yup from 'yup';

import { sectorAndActivitySchema, SectorAndActivityValue } from './user-general-data';

const yesOrNoField = yup
    .string()
    .typeError('Campo inválido.')
    .required('Campo é obrigatório.')
    .oneOf(['Sim', 'Não'], 'Campo inválido.')
    .default(null);

const userRegistrationAddonSchema = sectorAndActivitySchema.concat(
    yup.object().shape({
        questions: yup.object().shape({
            cf_score_de_que_forma_voce_usa_tours_virtuais: yup
                .string()
                .typeError('Campo inválido.')
                .required('Campo é obrigatório.')
                .oneOf(['Profissional', 'Pessoal'], 'Campo inválido.')
                .default(null),
            cf_score_ja_utilizou_realidade_virtual: yesOrNoField.clone(),
            cf_score_ja_utilizou_tour_virtual_360: yesOrNoField.clone(),
            cf_score_voce_sabe_gerar_imagens_360: yesOrNoField.clone()
        })
    })
);

export type UserRegistrationAddonValue = yup.TypeOf<typeof userRegistrationAddonSchema> & SectorAndActivityValue;

export default userRegistrationAddonSchema;
